module.exports = __webpack_public_path__ + "img/kolm-noolt.955a500b.svg";